// Демо-форма подсказок по банкам

import utils from "../utils";
import createComponent from "../vue";
import objectLink from "./object-link";
import Analytics from "../marketing/analytics";

const $ = window.jQuery;

const STATE = {
    bank: null,
    copied: false,
    type: "BANK",
};

const properties = {
    name() {
        let nameStr = "";
        if (this.bank.name) {
            nameStr = this.bank.name.payment || this.bank.name.full;
        }
        return nameStr;
    },

    fullname() {
        let fullname = "";
        const { name } = this.bank;
        if (name && name.payment && name.full) {
            fullname = name.full;
            // eslint-disable-next-line quotes
            if (fullname[0] === '"') {
                fullname = `«${fullname}»`;
            }
        }
        return fullname;
    },

    address() {
        const { address } = this.bank;
        if (address.data && address.data.qc === "0" && address.data.postal_code) {
            return utils.join([address.data.postal_code, address.value]);
        }
        return address.value;
    },

    rkc() {
        let rkcStr = "";
        const { rkc } = this.bank;
        if (rkc && rkc.name && rkc.name.payment) {
            rkcStr = rkc.name.payment;
            if (rkcStr.indexOf(rkc.opf.short) !== 0) {
                rkcStr = utils.join(["в", rkc.opf.short, rkc.name.payment], " ");
            } else {
                rkcStr = utils.join(["в", rkc.name.payment], " ");
            }
        }
        return rkcStr;
    },

    cbrLink() {
        const rnum = this.bank.registration_number.split("-")[0];
        return (
            `<a href="http://www.cbr.ru/banking_sector/credit/colist/?find=${
                rnum
            }" target="_blank">на сайте Банка России</a>`
        );
    },

    status() {
        let status = "";
        const { state } = this.bank;
        if (state && state.status) {
            if (state.status === "ACTIVE") {
                status = "Действующий";
            } else if (state.status === "LIQUIDATING") {
                status = "Ликвидируется";
            } else {
                status = utils.join(
                    ["Ликвидирован", utils.formatDate(state.liquidation_date)],
                    " ",
                );
            }
        }
        return status;
    },

    registrationDate() {
        let date = "";
        const { state } = this.bank;
        if (state && state.registration_date) {
            date = utils.formatDate(state.registration_date);
        }
        return date;
    },

    treasuryAccounts() {
        return this.bank.treasury_accounts.join(", ");
    },
};

const methods = {
    initSuggestions(serviceUrl, token) {
        const el = $(this.$refs.input);
        const params = {
            serviceUrl,
            token,
            type: this.type,
            count: 5,
            onSelect: this.onSelect,
            onSelectNothing: this.onSelectNothing,
        };
        el.suggestions(params);
    },

    onSelect(suggestion) {
        this.bank = suggestion.data;
        Analytics.reachGoal("SUG_DEMO_FORM_BANK");
    },

    onSelectNothing() {
        this.bank = null;
    },

    copyLink(event) {
        const url = objectLink.buildUrl("bank", this.bank.bic);
        objectLink.copy(url);
        objectLink.showCopied(this);
        event.preventDefault();
    },
};

function buildConfig(serviceUrl, token) {
    return {
        data() { return STATE; },
        mounted() {
            this.$nextTick(() => this.initSuggestions(serviceUrl, token));
        },
        computed: properties,
        methods,
    };
}

export default function Suggestions(serviceUrl, token) {
    const bankConfig = buildConfig(serviceUrl, token);

    createComponent(bankConfig, "#bank-vue-app");
}
